var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-center"},[_c('img',{staticClass:"head-banner-bg",attrs:{"src":require("../../assets/img/head-banner-bg.jpg")}}),_c('question-category-seller')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }